'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styled = require('./styled');

var _Tooltip = require('../next/Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Field = function Field(_ref) {
  var name = _ref.name,
      label = _ref.label,
      readOnly = _ref.readOnly,
      focused = _ref.focused,
      disabled = _ref.disabled,
      className = _ref.className,
      size = _ref.size,
      cols = _ref.cols,
      rows = _ref.rows,
      error = _ref.error,
      allowOverflow = _ref.allowOverflow,
      helpHint = _ref.helpHint,
      children = _ref.children,
      isTextarea = _ref.isTextarea,
      rest = _objectWithoutProperties(_ref, ['name', 'label', 'readOnly', 'focused', 'disabled', 'className', 'size', 'cols', 'rows', 'error', 'allowOverflow', 'helpHint', 'children', 'isTextarea']);

  return _react2.default.createElement(
    _styled.Container,
    _extends({
      allowOverflow: allowOverflow,
      className: 'life-field ' + className,
      readOnly: readOnly,
      disabled: disabled,
      size: size,
      focused: focused,
      cols: cols,
      rows: rows,
      error: error,
      hasHelpHint: helpHint
    }, rest),
    _react2.default.createElement(
      'header',
      null,
      _react2.default.createElement(
        _styled.Label,
        { htmlFor: name || label },
        label,
        helpHint && _react2.default.createElement(
          _Tooltip2.default,
          { html: helpHint, position: 'right', distance: 32 },
          _react2.default.createElement(_styled.HelpHint, null)
        )
      )
    ),
    _react2.default.createElement(
      'main',
      null,
      children
    ),
    (error || !isTextarea) && _react2.default.createElement(
      'footer',
      null,
      error && _react2.default.createElement(
        _styled.ErrorText,
        null,
        error
      )
    )
  );
};

Field.propTypes = process.env.NODE_ENV !== "production" ? {
  name: _propTypes2.default.string,
  label: _propTypes2.default.node.isRequired,
  helpHint: _propTypes2.default.node,
  readOnly: _propTypes2.default.bool,
  focused: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['large', 'small', '']),
  cols: _propTypes2.default.number,
  rows: _propTypes2.default.number,
  error: _propTypes2.default.string,
  allowOverflow: _propTypes2.default.bool,
  children: _propTypes2.default.any,
  isTextarea: _propTypes2.default.bool
} : {};

Field.defaultProps = {
  name: '',
  readOnly: true,
  focused: false,
  disabled: false,
  className: '',
  cols: 4,
  size: '',
  error: '',
  isTextarea: false
};

exports.default = Field;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/li-components/lib/Field/Field.js
// module id = 203
// module chunks = 14